module.exports = __webpack_public_path__ + "img/dente-sup.0679d16d.svg";